import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpDeleteFreelancerArea} from '@features/settings/http/settings.http.ts'
import {User} from '@features/user/types.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient.ts'

interface DeleteFreelancerAreaParams {
    userId: number
    areaId: number
}
export const useDeleteFreelancerArea = (
    options?: Omit<UseMutationOptions<unknown, unknown, DeleteFreelancerAreaParams>, 'mutationFn' | 'mutationKey'>
) => {
    const queryClient = useQueryClient()

    return useMutation<unknown, unknown, DeleteFreelancerAreaParams>({
        ...options,
        mutationFn: ({userId, areaId}) =>
            httpDeleteFreelancerArea({
                urlParams: {userId, areaId},
                params: {response_type: 'extended'}
            }),
        onError: errorHandler,
        onSuccess: async (data, variables, context) => {
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.ME]})
            queryClient.setQueryData(
                [QUERY_KEYS.ME],
                (previousData: User): User => ({
                    ...previousData,
                    photographerGeos: previousData.photographerGeos.filter(area => area.geoId != variables.areaId)
                })
            )
            options?.onSuccess?.(data, variables, context)
        }
    })
}
